import { z } from 'zod';

export enum DocumentType {
  PRESENTATIONS = 'Presentations',
  REPORTS = 'Reports',
  SPECIFICATIONS = 'Specifications',
  OTHER = 'Other',
}

export const DocumentTypeSchema = z.nativeEnum(DocumentType);
